const USER_SUBSCRIPTION_QUERY_KEYS = "user-subscription";

export const userSubscriptionQueryKeys = {
  all: [USER_SUBSCRIPTION_QUERY_KEYS] as const,
  account: function account() {
    return [USER_SUBSCRIPTION_QUERY_KEYS, "account"] as const;
  },
};
